module.exports = __webpack_public_path__ + "static/media/IMG_0038.db5308d0.jpg";